import { createAction } from '@reduxjs/toolkit';
import { IRequestsState } from '../reducers/requestsState';

export const resetRequestState = createAction<keyof IRequestsState, 'RESET_STATE'>('RESET_STATE');
